module.exports = __webpack_public_path__ + "static/media/medidor.611e871e.svg";